import FileActions from '../actions/FileActions';

const initialState = {
  allDownloadFiles: [],
  initiateDownload: false,
  deleteFile: false,
  downloadUrl: {},
};

export type Downloads = {
  allDownloadFiles: any;
  initiateDownload: boolean;
  deleteFile: boolean;
  downloadUrl: any;
};

export default (state: Downloads = initialState, action: any) => {
  switch (action.type) {
    case FileActions.MY_DOWNLOADS_LOADING:
      return {
        ...state,
        allDownloadFiles: state.allDownloadFiles,
      };

    case FileActions.MY_DOWNLOADS_SUCCESS:
      return {
        ...state,
        allDownloadFiles: action.data,
      };

    case FileActions.MY_DOWNLOADS_ERROR:
      return {
        ...state,
        allDownloadFiles: action.data,
      };

    case FileActions.INITIATE_DOWNLOAD_FILE: {
      return {
        ...state,
        initiateDownload: action.payload,
      };
    }

    case FileActions.DELETE_FILES_LOADING:
      return {
        ...state,
        deleteFile: false,
      };
    case FileActions.DELETE_FILES_SUCCESS:
      return {
        ...state,
        deleteFile: true,
      };
    case FileActions.DELETE_FILES_ERROR:
      return {
        ...state,
        deleteFile: false,
      };

    case FileActions.TOGGLE_DELETE_STATE:
      return {
        ...state,
        deleteFile: action.payload,
      };

    case FileActions.DOWNLOAD_FILE_LOADING: {
      return {
        ...state,
        downloadUrl: action.data,
      };
    }
    case FileActions.DOWNLOAD_FILE_SUCCESS: {
      return {
        ...state,
        downloadUrl: action.data,
      };
    }
    case FileActions.DOWNLOAD_FILE_ERROR: {
      return {
        ...state,
        downloadUrl: action.data,
      };
    }
    case FileActions.DOWNLOAD_FILE_DONE: {
      return {
        ...state,
        downloadUrl: action.data,
      };
    }

    default:
      return state;
  }
};
